// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.error {\n  font-weight: bold;\n  color: #C00000;\n}", "",{"version":3,"sources":["webpack://src/styles.scss"],"names":[],"mappings":"AAAA,8EAAA;AACA;EACI,iBAAA;EACA,cAAA;AACJ","sourcesContent":["/* You can add global styles to this file, and also import other style files */\r\n.error {\r\n    font-weight: bold;\r\n    color: #C00000;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
